import { useState } from 'react';
import { ArtificialIntelligenceIcon } from 'foundations-assets/icons/components/ArtificialIntelligenceIcon';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { H2 } from 'foundations-components/transitional/components/H2';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { useGenerateDemoContentMutation } from '../../__generated__/chirp/com/hubspot/partner/demo/rpc/PartnerDemoDdgRpc.hooks';
import { ALL_FEATURE_TYPES, HUBS } from '../constants/hubsAndFeatures';
import { HubLevelSelector } from './HubLevelSelector';
import { IndustrySelector } from './IndustrySelector';
import { SuccessScreen } from './SuccessScreen';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const defaultParcelsUpdate = Object.assign({}, Object.fromEntries(HUBS.map(hub => [hub, 'ENTERPRISE'])), {
  reportingEnabled: false
});
export function DemoDataGenerationPanel({
  demoPortalId,
  onClose,
  onSuccess
}) {
  const [industry, setIndustry] = useState();
  const [parcelsUpdate, setParcelsUpdate] = useState(defaultParcelsUpdate);
  const [mutate, {
    data,
    loading,
    error
  }] = useGenerateDemoContentMutation();
  const handleSubmit = () => {
    void mutate({
      variables: {
        demoPortalId,
        industry,
        featureTypes: ALL_FEATURE_TYPES,
        parcelsUpdate
      }
    });
  };
  return /*#__PURE__*/_jsxs(Panel, {
    width: 500,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        gap: 8,
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "partnerDemoPortalUi.panel.title"
          })
        }), /*#__PURE__*/_jsx(Badge, {
          use: "beta",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "partnerDemoPortalUi.panel.betaBadge"
          })
        })]
      })
    }), data ? /*#__PURE__*/_jsx(SuccessScreen, {
      demoPortalId: demoPortalId,
      industry: industry,
      onClose: () => {
        onClose();
        onSuccess(data);
      }
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(PanelBody, {
        children: [loading && /*#__PURE__*/_jsx(LoadingOverlay, {
          contextual: true
        }), /*#__PURE__*/_jsxs(PanelSection, {
          children: [/*#__PURE__*/_jsx(IndustrySelector, {
            value: industry,
            onChange: setIndustry
          }), /*#__PURE__*/_jsx(HubLevelSelector, {
            parcelsUpdate: parcelsUpdate,
            onChange: setParcelsUpdate
          }), /*#__PURE__*/_jsx(Alert, {
            type: "info",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "partnerDemoPortalUi.panel.betaAlert"
            })
          }), error && /*#__PURE__*/_jsx(Alert, {
            type: "danger",
            titleText: unescapedText('partnerDemoPortalUi.panel.errorAlert.title'),
            children: error.message
          })]
        })]
      }), /*#__PURE__*/_jsx(PanelFooter, {
        align: "right",
        children: /*#__PURE__*/_jsxs(LoadingButton, {
          use: "primary",
          onClick: handleSubmit,
          loading: loading,
          children: [/*#__PURE__*/_jsx(ArtificialIntelligenceIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "partnerDemoPortalUi.panel.actions.generate"
          })]
        })
      })]
    })]
  });
}